export default "__VITE_PUBLIC_ASSET__ba1962ca__"